import { render, staticRenderFns } from "./WinModal.vue?vue&type=template&id=0a6de6d4&scoped=true"
import script from "./WinModal.vue?vue&type=script&lang=js"
export * from "./WinModal.vue?vue&type=script&lang=js"
import style0 from "./WinModal.vue?vue&type=style&index=0&id=0a6de6d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6de6d4",
  null
  
)

export default component.exports